import { AuthDataStatus } from "../../../_statics/AuthDataStatus";
import { AuthDataType } from "../../../_statics/AuthDataType";
import dateUtils from "../../../_services/date-utils";

const SETUP_GRACE_PERIOD_MS = 1000 * 60 * 10;

export const connectionStatusSeverity = (status) => {
    if (status === AuthDataStatus.REVOKED) {
        return "error";
    }
    if (status === AuthDataStatus.SETUP) {
        return "warning";
    }
    return "ok";
};

const msSinceCreation = (connection) =>
    dateUtils.getDurationBetweenInMs(new Date(connection.createdAt), new Date());

export const isAwaitingSetup = (connection) =>
    connection.status === AuthDataStatus.SETUP &&
    (!connection.createdAt || msSinceCreation(connection) < SETUP_GRACE_PERIOD_MS);

// PayPal is the only integration that leaves a setup hanging rather than failing it,
// so a stalled one has to be told apart from one that is merely still running.
export const isStalledPaypalSetup = (connection) =>
    connection.status === AuthDataStatus.SETUP &&
    connection.type === AuthDataType.PAYPAL.identifier &&
    !!connection.createdAt &&
    msSinceCreation(connection) >= SETUP_GRACE_PERIOD_MS;
